module.exports = __webpack_public_path__ + "img/icon_t_suc.5e72ecb4.png";